import React from 'react';
import { formatMatchTime } from '../utils/time';

const formatDate = (value) => {
  try {
    return new Date(`${value}T12:00:00`).toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch (error) {
    return value;
  }
};

const getCouponBadgeLabel = (couponType = '') => {
  if (couponType.startsWith('daytime_')) return 'Gunduz Kuponu';
  if (couponType.startsWith('evening_')) return 'Aksam Kuponu';
  return 'Editor Kuponu';
};

const getCouponSubtitle = (coupon = {}) => {
  if (coupon.title) return coupon.title;
  if (coupon.couponType?.includes('2_leg')) return '2 Maclik Guvenli Kupon';
  if (coupon.couponType?.includes('3_leg')) return '3 Maclik Premium Kupon';
  return 'Editor Kuponu';
};

const formatNumber = (value, digits = 1) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return '-';
  return numeric.toFixed(digits);
};

const PremiumCouponPoster = ({ coupon }) => {
  const legs = Array.isArray(coupon?.legs) ? coupon.legs.slice(0, 3) : [];
  const isEditor = String(coupon?.couponType || '').startsWith('editor_');
  const getTeamName = (team) => {
    if (!team) return '-';
    if (typeof team === 'string') return team;
    return team.name || '-';
  };
  const getLeagueName = (league) => {
    if (!league) return '-';
    if (typeof league === 'string') return league;
    return league.name || '-';
  };

  return (
    <article className="coupon-poster">
      <img
        className="coupon-poster-background"
        src="/premium-coupon-template.jpg"
        alt="Premium kupon saha tasarimi"
        loading="lazy"
      />
      <div className="coupon-poster-overlay">
        <div className="coupon-poster-top">
          <span className={`coupon-poster-badge ${isEditor ? 'editor' : ''}`}>
            {getCouponBadgeLabel(coupon?.couponType)}
          </span>
          <span className="coupon-poster-date">{formatDate(coupon?.couponDate)}</span>
        </div>

        <div className="coupon-poster-stage" aria-hidden="true"></div>

        <div className="coupon-poster-summary">
          <strong>{getCouponSubtitle(coupon)}</strong>
          <div className="coupon-poster-summary-meta">
            <span>Seviye: {coupon?.qualityLevel || 'B Temkinli'}</span>
            <span>Toplam Oran: {formatNumber(coupon?.totalOdds, 2)}</span>
          </div>
          <div className="coupon-poster-summary-meta">
            <span>Ort. Guven: %{Math.round(Number(coupon?.averageConfidence || 0))}</span>
            <span>Ort. Edge: +{formatNumber(coupon?.averageEdge, 1)}</span>
          </div>
        </div>

        <details className="coupon-poster-accordion" open>
          <summary>Detaylari Ac</summary>
          <div className="coupon-poster-list">
            {legs.map((leg, index) => (
              <div className="coupon-poster-item" key={`${coupon?.couponType}-${leg.matchId || index}`}>
                <div className="coupon-poster-item-head">
                  <span className="coupon-poster-index">{index + 1}</span>
                  <span className="coupon-poster-match">
                    {getTeamName(leg.homeTeam)} - {getTeamName(leg.awayTeam)}
                  </span>
                  <div className="coupon-poster-head-meta">
                    <span className={`coupon-poster-edge-badge ${Number(leg.edge || 0) > 0 ? 'positive' : ''}`}>
                      Edge {Number(leg.edge || 0) > 0 ? '+' : ''}{formatNumber(leg.edge, 1)}
                    </span>
                    <span className="coupon-poster-time">{formatMatchTime(leg.matchDate)}</span>
                  </div>
                </div>
                <div className="coupon-poster-item-meta">
                  <div>
                    <strong className="strong-choice-signal">
                      <span className="strong-choice-dot" aria-hidden="true"></span>
                      {leg.market}
                    </strong>
                    <div className="coupon-poster-item-submeta">
                      <span>{getLeagueName(leg.league)}</span>
                      {leg.recommendationTag ? <span>{leg.recommendationTag}</span> : null}
                    </div>
                  </div>
                  <div className="coupon-poster-item-values">
                    <span>Oran {formatNumber(leg.odds, 2)}</span>
                    <span>Model %{Math.round(Number(leg.modelProbability || 0))}</span>
                    <span>Guven %{Math.round(Number(leg.confidence || 0))}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </details>

        <div className="coupon-poster-insight">
          {coupon?.aiInsight}
        </div>

        <div className="coupon-poster-footer">
          <div className="coupon-poster-footer-confidence">
            <span>Kupon Skoru</span>
            <strong>{formatNumber(coupon?.couponScore, 1)}</strong>
          </div>
          <div className="coupon-poster-footer-warning">
            <strong>BUNLAR SADECE ANALIZ VE TAHMINDIR</strong>
          </div>
        </div>
      </div>
    </article>
  );
};

export default PremiumCouponPoster;
